import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

const ContentSection = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [imgSource, setImgSource] = useState("mobile");

  useEffect(() => {
    isDesktop ? setImgSource("desktop") : setImgSource("mobile");
    console.log(isDesktop, imgSource);
  }, [isDesktop]);

  return (
    <section className="section-hero wrapper">
      <img
        src={`./assets/${imgSource}/image-interactive.jpg`}
        alt="Men with a vr equipement"
      />
      <div className="txt-hero">
        <h2> The leader in interactive VR</h2>
        <p>
          Founded in 2011, Loopstudios has been producing world-class virtual
          reality projects for some of the best companies around the globe. Our
          award-winning creations have transformed businesses through digital
          experiences that bind to their brand.
        </p>
      </div>
    </section>
  );
};

export default ContentSection;
